angular
  .module('vppApp')
  .service('ModuleService', ModuleService);

ModuleService.$inject = ['$http', '$rootScope', 'apiFactory'];

function ModuleService($http, $rootScope, apiFactory) {
  var moduleService = {};
  // response from /register/details/{site}
  var _siteModuleDetails = {};
  var _whichSite = "";
  var _mppServiceBranch = {};
  var _mppStatus = {};
  var _gmedposition = {};
  var _gmedschooltype = {};
  var _cgpStates = {};
  var _cgpCollegelevel = {};
  var _frdPosition = {};
  //
  moduleService.partnerName;
  moduleService.subsidiaries;
  moduleService.serverError;
  moduleService.partnerID;
  //
  moduleService.partnerClientCode;
  moduleService.currentPartnerName;
  moduleService.currentPartnerId;
  moduleService.currentSubsidiaryId;
  moduleService.currentSubsidiaryName;
  moduleService.currentSchoolType;
  moduleService.currentPosition;
  moduleService.currentpartnerList;
  moduleService.state;
  moduleService.currentLevel;
  moduleService.currentBranch;
  moduleService.currentStatus;



  moduleService.setModuleDetails = function (moduleDetails, whichSite) {
    _siteModuleDetails = moduleDetails;
    _whichSite = whichSite;
    //console.log(_siteModuleDetails);
    //console.log(_whichSite);
    processSiteSelects();

  };

  //// Process Site Specific Dropdowns for Step-3
  function processSiteSelects() {
    // mpp response.data.securityQuestions
    if (_whichSite === "mpp") {
      //console.log("processSiteSelects mpp ", _siteModuleDetails.moduleInfo.agencyConfigMap.accountAttribute_mppStatus.dropdownList);
      _mppServiceBranch = _siteModuleDetails.moduleInfo.agencyConfigMap.accountAttribute_servicebranch.dropdownList;
      _mppStatus = _siteModuleDetails.moduleInfo.agencyConfigMap.accountAttribute_mppStatus.dropdownList;
      moduleService.currentBranch = _siteModuleDetails.moduleInfo.agencyConfigMap.accountAttribute_servicebranch.currentAccountAttributeVal;
      processBranches();
      moduleService.currentStatus = _siteModuleDetails.moduleInfo.agencyConfigMap.accountAttribute_mppStatus.currentAccountAttributeVal;
      processMilStatus();
    } else if (_whichSite === "gmed") {
      // console.log("processSiteSelects GMED", _siteModuleDetails.moduleInfo.agencyConfigMap.accountAttribute_schooltype.dropdownList);
      _gmedposition = _siteModuleDetails.moduleInfo.agencyConfigMap.accountAttribute_position.dropdownList;
      _gmedschooltype = _siteModuleDetails.moduleInfo.agencyConfigMap.accountAttribute_schooltype.dropdownList;
      moduleService.currentSchoolType = _siteModuleDetails.moduleInfo.agencyConfigMap.accountAttribute_schooltype.currentAccountAttributeVal;
      processSchoolType();
      moduleService.currentPosition = _siteModuleDetails.moduleInfo.agencyConfigMap.accountAttribute_position.currentAccountAttributeVal;
      processPosition();
    } else if (_whichSite === "cgp") {
      _cgpStates = _siteModuleDetails.moduleInfo.agencyConfigMap.partnerAssociation.stateList;
      _cgpCollegelevel = _siteModuleDetails.moduleInfo.agencyConfigMap.accountAttribute_collegelevel.dropdownList;
      moduleService.state = _siteModuleDetails.moduleInfo.agencyConfigMap.partnerAssociation.state;
      moduleService.currentPartnerName = _siteModuleDetails.moduleInfo.agencyConfigMap.partnerAssociation.partnerId;
      moduleService.currentPartnerId = _siteModuleDetails.moduleInfo.agencyConfigMap.partnerAssociation.partnerId;
      moduleService.currentpartnerList = _siteModuleDetails.moduleInfo.agencyConfigMap.partnerAssociation.partnerList;
      // processCollegeName();
      moduleService.currentLevel = _siteModuleDetails.moduleInfo.agencyConfigMap.accountAttribute_collegelevel.currentAccountAttributeVal;
      processLevel();
    } else if (_whichSite === "sup" || _whichSite === "ded") {
      moduleService.currentPartnerName = _siteModuleDetails.moduleInfo.agencyConfigMap.partnerClientCode.partnerName;
      moduleService.currentSubsidiaryId = _siteModuleDetails.moduleInfo.agencyConfigMap.partnerClientCode.subsidiaryId;
      moduleService.currentSubsidiaryName = _siteModuleDetails.moduleInfo.agencyConfigMap.partnerClientCode.subsidiaryName;
    }
  }

  // Get site specific information
  function processBranches() {
    for (var name in _mppServiceBranch) {
      if (_mppServiceBranch.hasOwnProperty(name) && name == moduleService.currentBranch) {
        moduleService.currentBranch = _mppServiceBranch[name];
      }
    }
  }
  function processMilStatus() {
    for (var name in _mppStatus) {
      if (_mppStatus.hasOwnProperty(name) && name == moduleService.currentStatus) {
        moduleService.currentStatus = _mppStatus[name];
      }
    }
  }

  function processSchoolType() {
    for (var name in _gmedschooltype) {
      if (_gmedschooltype.hasOwnProperty(name) && name == moduleService.currentSchoolType) {
        moduleService.currentSchoolType = _gmedschooltype[name];
      }
    }
  }
  function processPosition() {
    for (var name in _gmedposition) {
      if (_gmedposition.hasOwnProperty(name) && name == moduleService.currentPosition) {
        moduleService.currentPosition = _gmedposition[name];
      }
    }
  }
  function processLevel() {
    for (var name in _cgpCollegelevel) {
      if (_cgpCollegelevel.hasOwnProperty(name) && name == moduleService.currentLevel) {
        moduleService.currentLevel = _cgpCollegelevel[name];
      }
    }
  }
  function processCollegeName() {
    for (var name in moduleService.currentpartnerList) {
      if (moduleService.currentpartnerList.hasOwnProperty(name) && name == moduleService.currentPartnerId) {
        moduleService.currentPartnerName = moduleService.currentpartnerList[name];
      }
    }
  }
  // Getters
  moduleService.getModuleDetailsGMEDPosition = function () {
    return _gmedposition;
  };
  moduleService.getModuleDetailsGMEDSchoolType = function () {
    return _gmedschooltype;
  };
  moduleService.getModuleDetailsMPPServiceBranch = function () {
    return _mppServiceBranch;
  };
  moduleService.getModuleDetailsMPPStatus = function () {
    return _mppStatus;
  };
  moduleService.getModuleDetailsCGPStates = function () {
    return _cgpStates;
  };
  moduleService.getModuleDetailsCGPCollegeLevel = function () {
    return _cgpCollegelevel;
  };

  /// Fetch Partner and Subsidiary Code
  //
  // process moduleDetails for later use
  moduleService.clearSiteModule = function () {
    delete moduleService.partnerName;
    delete moduleService.subsidiaries;
    delete moduleService.serverError;
    delete moduleService.subsidiaryId;
    delete moduleService.partnerID;
  };

  moduleService.processPartnerAndSubsidiaryForCode = function (scope) {
    delete moduleService.partnerName;
    delete moduleService.subsidiaries;
    delete moduleService.serverError;
    // SUP & MPP
    if (scope.user.moduleDetails.partnerClientCode.partnerCode && scope.user.moduleDetails.partnerClientCode.partnerCode.length > 5) {
      apiFactory.userRegistrationUserModule("partnerClientCode", "partnerAndSubsidiaryForCode?partnerCode=" + scope.user.moduleDetails.partnerClientCode.partnerCode)
        .then(function successRegistrationUserModule(response) {
          moduleService.partnerName = response.data.data.partnerName;
          moduleService.subsidiaries = response.data.data.subsidiaries;
          moduleService.subsidiaryId = response.data.data.subsidiaryId;
          moduleService.partnerID = response.data.data.partnerId;
        }, function errorCallback(response) {
          moduleService.serverError = response.data.errors;
        });
    }
  };

  moduleService.processPartnerListForState = function (scope) {


    apiFactory.userRegistrationUserModule("partnerAssociation", "partnerListForState?state=" + scope.user.moduleDetails.partnerAssociation.state)
      .then(function successRegistrationUserModule(response) {
        let sortingarr = Object.entries(response.data.data); // [[key1, value1], [key2, value2], ...]
        sortingarr = sortingarr.sort((a,b) => a[1].toUpperCase().localeCompare(b[1].toUpperCase())); //sort by value
        var newCollegeObject = {};
        sortingarr.forEach (x => {
          newCollegeObject['"' + x[0] + '"'] = x[1];
        });
        moduleService.cgpColleges = newCollegeObject;
      }, function errorCallback(response) {
        moduleService.serverError = response.data.errors;
      });

  };


  /// End Process Module Details

  return moduleService;
}
